// Shared request flow; the picker returns null on cancellation or an asset -> image-key map.
export async function requestAssetReport(request, chooseImages, loading) {
  const wasLoading = Boolean(loading && loading.instance);
  try {
    const preview = await request({ image_options: 1 });
    if (!preview.data || !preview.data.image_options) return preview;
    const { mode, assets } = preview.data;
    if (mode !== 'images' || !assets.some(asset => asset.images.length)) return await request({});
    if (wasLoading) loading.hide();
    const selection = await chooseImages(assets);
    if (selection === null) return { data: null, cancelled: true };
    if (wasLoading) loading.show();
    return await request({ report_images: JSON.stringify(selection) });
  } finally {
    if (wasLoading) loading.hide();
  }
}
